export const isFetching = state =>
  state.integrations.stripeConnect.auth.fetching;
export const status = state =>
  state.integrations.stripeConnect.auth.status || {};
